type MarkupRuleType = {
  h2: string[];
  h3: string[];
  p: string[];
  blockquote: string[];
  a: string[];
  img: string[];
  ul: string[];
  ol: string[];
  li: string[];
  table: string[];
  th: string[];
  td: string[];
  pre: string[];
  code: string[];
  em: string[];
};

export const markupRuleForDom: MarkupRuleType = {
  h2: [
    'text-lg',
    'font-bold',
    'leading',
    'border-collapse',
    'border-l-8',
    'border-l-primary-1',
    'px-12',
    'py-16',
    'text-left',
    'my-12',
  ],
  h3: [
    'text-md',
    'font-bold',
    'leading',
    'border-collapse',
    'border-b-[1px]',
    'border-b-line',
    'p-8',
    'text-left',
    'my-12',
  ],
  p: ['text-base', 'leading-[25px]', 'tracking-wide', 'mb-24'],
  blockquote: [
    'text-base',
    'leading',
    'border-collapse',
    'border-l-4',
    'border-l-line',
    'px-12',
    'py-16',
    'text-left',
    'my-8',
  ],
  a: ['text-link', 'text-base', 'leading', 'hover:underline'],
  img: ['mx-auto', 'my-8'],
  ul: ['px-4', 'list-inside', 'list-none', 'my-8'],
  ol: ['px-4', 'list-inside', 'list-none', 'my-8'],
  li: ['text-base', 'leading', 'pl-20'],
  table: [
    'border-collapse',
    'border-black-1',
    'border-[1px]',
    'w-full',
    'my-12',
  ],
  th: [
    'text-base',
    'leading',
    'bg-background-1',
    'border-collapse',
    'border-black-1',
    'border-[1px]',
  ],
  td: [
    'text-base',
    'leading',
    'border-collapse',
    'border-black-1',
    'border-[1px]',
    'p-4',
  ],
  pre: ['bg-background-1', 'p-8', 'my-8'],
  code: ['text-base', 'leading'],
  em: ['font-bold', 'font-italic'],
};

export const addStyleToResourceContent = async (): Promise<void> => {
  const containerList = document.querySelectorAll('[data-resource-content]');

  if (containerList && containerList.length > 0) {
    for (const container of containerList) {
      addStyleToElement(container);
    }
  }

  await Promise.resolve();
};

const addStyleToElement = (container: Element) => {
  const h2 = container.querySelectorAll('h2');
  for (const element of h2) {
    element.classList.add(...markupRuleForDom.h2);
  }

  const h3 = container.querySelectorAll('h3');
  for (const element of h3) {
    element.classList.add(...markupRuleForDom.h3);
  }

  const p = container.querySelectorAll('p');
  for (const element of p) {
    element.classList.add(...markupRuleForDom.p);
  }

  const blockquote = container.querySelectorAll('blockquote');
  for (const element of blockquote) {
    element.classList.add(...markupRuleForDom.blockquote);
  }

  const a = container.querySelectorAll('a');
  for (const element of a) {
    element.classList.add(...markupRuleForDom.a);
  }

  const img = container.querySelectorAll('img');
  for (const element of img) {
    element.classList.add(...markupRuleForDom.img);
  }

  const ul = container.querySelectorAll('ul');
  for (const element of ul) {
    element.classList.add(...markupRuleForDom.ul);
  }

  const ol = container.querySelectorAll('ol');
  for (const element of ol) {
    element.classList.add(...markupRuleForDom.ol);
  }

  const li = container.querySelectorAll('li');
  for (const element of li) {
    element.classList.add(...markupRuleForDom.li);
  }

  const table = container.querySelectorAll('table');
  for (const element of table) {
    element.classList.add(...markupRuleForDom.table);
  }

  const th = container.querySelectorAll('th');
  for (const element of th) {
    element.classList.add(...markupRuleForDom.th);
  }

  const td = container.querySelectorAll('td');
  for (const element of td) {
    element.classList.add(...markupRuleForDom.td);
  }

  const pre = container.querySelectorAll('pre');
  for (const element of pre) {
    element.classList.add(...markupRuleForDom.pre);
  }

  const code = container.querySelectorAll('code');
  for (const element of code) {
    element.classList.add(...markupRuleForDom.code);
  }

  const em = container.querySelectorAll('em');
  for (const element of em) {
    element.classList.add(...markupRuleForDom.em);
  }
};
